import { useCouponStore } from './useCouponStore.js';
/**
 * Subscribes to selected changes for a given coupon collection.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.selector State selector
 * @returns selected value
 */
export function useSubscribedCouponCollection({ couponId, selector, }) {
    // TODO: [CA]: re-enable this code since it re-renders more than necessary
    // Zustand createStore API: https://github.com/pmndrs/zustand/blob/main/src/vanilla.ts#L60
    // useStore: https://github.com/pmndrs/zustand/blob/main/src/react.ts#L26-L37
    // shallow: https://github.com/pmndrs/zustand/blob/main/src/vanilla/shallow.ts
    // When enabling this, we should have two get controllers, one for coupon and one for board.
    // each of them should return a user friendly version of it's model; like board.outcomes, board.userOutcomes and board.reduction
    // const getCouponController = getInstanceClient('IGetCouponController');
    // const [getSnapshot, subscribe] = useMemo(() => {
    //   // eslint-disable-next-line no-console
    //   console.log('[changed]', 'store');
    //   return getCouponController({ couponId, couponIndex });
    // }, [couponId, couponIndex, getCouponController]);
    // // Third argument _should_ be initial data from coupon store, this will work for now
    // const coupon = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    // const prev = useRef<TSubscribe>(undefined);
    // const next = selector(coupon);
    // if (prev.current === undefined || !shallow(prev.current, next)) {
    //   // eslint-disable-next-line no-console
    //   console.log('[changed]', prev.current, next);
    //   prev.current = next;
    // }
    // return prev.current;
    return useCouponStore((store) => {
        const couponCollection = store.Coupons[couponId];
        return selector(couponCollection);
    });
}
//# sourceMappingURL=useSubscribedCouponCollection.js.map